/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Ignore_Stamps_HintInputs */

const cs_ebr_ignore_stamps_hint = /** @type {(inputs: Ebr_Ignore_Stamps_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normálně stahujeme jen položky změněné od posledního importu.`)
};

const en_ebr_ignore_stamps_hint = /** @type {(inputs: Ebr_Ignore_Stamps_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normally we only fetch items changed since the last import.`)
};

/**
* | output |
* | --- |
* | "Normally we only fetch items changed since the last import." |
*
* @param {Ebr_Ignore_Stamps_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_ignore_stamps_hint = /** @type {((inputs?: Ebr_Ignore_Stamps_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Ignore_Stamps_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_ignore_stamps_hint(inputs)
	return cs_ebr_ignore_stamps_hint(inputs)
});